import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import '../node_modules/react-modal-video/scss/modal-video.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './css/fontawesome.css';
import './css/themify-icons.css';
import './css/animate.css';
import './sass/style.scss';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { HelmetProvider } from 'react-helmet-async';

const RECAPTCHA_SITE_KEY = '6LeohI0rAAAAAHySIp6lao_hEmDFiP7QwDpS1ajA';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <GoogleReCaptchaProvider
        reCaptchaKey={RECAPTCHA_SITE_KEY}
        scriptProps={{ async: true, defer: true, appendTo: 'head' }}
        container={{ parameters: { badge: 'inline' } }}
      >
        <App />
      </GoogleReCaptchaProvider>
    </HelmetProvider>
  </React.StrictMode>
);


reportWebVitals();
